module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'choice-img': _vm.hasImage
    },
    attrs: {
      "name": "choice"
    }
  }, [(_vm.hasImage) ? _c('div', {
    staticClass: "set-img"
  }, [(_vm.choice.image && _vm.foundImage) ? [_c('img', {
    staticClass: "img-circle",
    attrs: {
      "src": _vm.baseURL + _vm.filePath.load + _vm.choice.image
    },
    on: {
      "error": function($event) {
        _vm.setImgNotFound()
      }
    }
  })] : [_c('img', {
    staticClass: "img-circle",
    attrs: {
      "src": require("static/images/no-image-landscape.png")
    }
  })]], 2) : _vm._e(), _vm._v(" "), _c('div', {
    class: 'dash-bg-color-skin-light-10 ' + [_vm.hasImage ? 'progress-bg' : 'choice']
  }, [_c('div', {
    staticClass: "progress dash-bg-color-skin-dark-10",
    style: ({
      width: _vm.progressPercent(_vm.choice.number, _vm.poll.totalVote)
    })
  }), _vm._v(" "), _c('v-touch', {
    staticClass: "choosentext cursor-pointer",
    attrs: {
      "title": "double click for vote"
    },
    on: {
      "doubletap": function($event) {
        _vm.saveSelectChoice()
      }
    }
  }, [_c('div', {
    staticClass: "choose-space"
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.choice.selected === 'Y'),
      expression: "choice.selected === 'Y'"
    }],
    staticClass: "fa fa-check"
  })]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.choice.text))]), _vm._v(" "), _c('div', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.choice.number))])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-818d1bec!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/poll/choice.vue
// module id = 3920
// module chunks = 1